<!--
과금 재결제 모달 컴포넌트
------------------------------------
사용: app.$refs['billing-retry'].form({ id, ... })
패턴: set-restrict-register.vue 참조
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical" style="width: 640px; max-width: 90vw">

            <div class="uk-modal-header">
                <h4 class="uk-text-center">과금 재결제</h4>
            </div>

            <div class="uk-modal-body" style="overflow-y: auto; max-height: 70vh">

                <!-- 과금 정보 -->
                <table class="uk-table uk-table-small uk-table-divider" style="font-size: 13px; margin: 0; table-layout: fixed; width: 100%">
                    <colgroup>
                        <col style="width: 100px">
                        <col>
                    </colgroup>
                    <tbody>
                    <tr>
                        <td class="uk-text-muted">과금번호</td>
                        <td>#{{ billing.id }}</td>
                    </tr>
                    <tr>
                        <td class="uk-text-muted">과금일</td>
                        <td>{{ billing.billing_date }}</td>
                    </tr>
                    <tr v-if="billing.user_nick">
                        <td class="uk-text-muted">회원사</td>
                        <td>{{ billing.user_nick }}</td>
                    </tr>
                    <tr>
                        <td class="uk-text-muted">과금타입</td>
                        <td>{{ billing.billing_type_text }}</td>
                    </tr>
                    <tr>
                        <td class="uk-text-muted">결제수단</td>
                        <td>{{ billing.payment_method_label }}</td>
                    </tr>
                    <tr>
                        <td class="uk-text-muted">결제금액</td>
                        <td style="font-weight: 700; color: #1e87f0">{{ numberFormat(billing.total_amount) }}원</td>
                    </tr>
                    <tr v-if="billing.arrears_reason">
                        <td class="uk-text-muted">실패 사유</td>
                        <td class="uk-text-danger" style="word-break: break-all">{{ billing.arrears_reason }}</td>
                    </tr>
                    </tbody>
                </table>

                <!-- 결제방법 선택 -->
                <div style="margin-top: 16px; padding: 12px 16px; background: #f8f9fa; border: 1px solid #e5e5e5; border-radius: 4px">
                    <div style="font-size: 13px; font-weight: 600; color: #333; margin-bottom: 8px">결제방법 선택</div>
                    <label v-if="!isGoodsCost"
                           style="display: block; padding: 6px 0; font-size: 13px; cursor: pointer">
                        <input type="radio" name="retry_method" value="current"
                               v-model="selectedMethod" style="margin-right: 6px">
                        현재 결제수단으로 재결제
                        <span style="color: #888; font-size: 12px">({{ billing.payment_method_label }})</span>
                    </label>
                    <label v-if="isGoodsCost || billing.payment_method_type !== 1"
                           style="display: block; padding: 6px 0; font-size: 13px; cursor: pointer">
                        <input type="radio" name="retry_method" value="deposit"
                               v-model="selectedMethod" style="margin-right: 6px">
                        예치금으로 재결제
                    </label>
                </div>

                <!-- 안내: 물품가비용 예치금 전용 (BUG-065) -->
                <div v-if="isGoodsCost" class="uk-alert uk-alert-warning" style="margin-top: 12px; padding: 10px 15px">
                    <i class="material-icons uk-text-middle" style="font-size: 18px">info</i>
                    물품가비용은 예치금으로만 결제됩니다.<br>
                    <span style="font-size: 12px; color: #888">예치금 잔액이 부족하면 결제에 실패합니다.</span>
                </div>

                <!-- 안내 -->
                <div v-if="!isGoodsCost && selectedMethod === 'current'"
                     class="uk-alert uk-alert-warning" style="margin-top: 12px; padding: 10px 15px">
                    <i class="material-icons uk-text-middle" style="font-size: 18px">info</i>
                    현재 등록된 결제수단으로 재결제를 진행합니다.<br>
                    <span style="font-size: 12px; color: #888">결제수단이 변경된 경우, 변경된 결제수단으로 결제됩니다.</span>
                </div>

                <div v-if="!isGoodsCost && selectedMethod === 'deposit'"
                     class="uk-alert uk-alert-warning" style="margin-top: 12px; padding: 10px 15px">
                    <i class="material-icons uk-text-middle" style="font-size: 18px">info</i>
                    예치금으로 재결제합니다. 카드 수수료가 제거되어 결제금액이 변경될 수 있습니다.<br>
                    <span style="font-size: 12px; color: #888">예치금 잔액이 부족하면 결제에 실패합니다.</span>
                </div>

                <!-- 에러 메시지 -->
                <div v-if="errorMsg" class="uk-alert uk-alert-danger" style="margin-top: 12px">
                    {{ errorMsg }}
                </div>
            </div>

            <div class="uk-modal-footer uk-text-right">
                <button type="button"
                        class="uk-button uk-button-default uk-modal-close">
                    <span uk-icon="icon: close"></span> 취소
                </button>
                <button type="button"
                        class="uk-button uk-button-danger"
                        :disabled="submitting"
                        @click="submit()">
                    <i class="material-icons uk-text-middle" style="font-size: 18px">refresh</i>
                    재결제 실행
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            csrfToken: String,
        },
        data: function () {
            return {
                billing: {},
                errorMsg: '',
                submitting: false,
                selectedMethod: 'current',
            };
        },
        computed: {
            /**
             * 물품가비용 과금 여부 (BUG-065)
             * billing_type = 12 → App\Code\Billing\Type::GOODS_COST (예치금 결제만 허용)
             */
            isGoodsCost: function () {
                return this.billing.billing_type === 12;
            },
        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm: function () {
                UIkit.modal(this.$el).show();
            },

            /**
             * 폼 — 외부에서 호출
             * @param {Object} billingData 과금 정보 객체
             */
            form: function (billingData) {
                this.billing = billingData;
                this.errorMsg = '';
                this.submitting = false;
                // BUG-065: 물품가비용은 "현재 결제수단" 라디오를 숨기므로 예치금을 기본 선택
                this.selectedMethod = (billingData.billing_type === 12) ? 'deposit' : 'current';
                this.displayForm();
            },

            /**
             * 결제수단 타입 코드 (override_payment_method_type)
             * null = 현재 결제수단 (기존 동작)
             * 1 = 예치금 (DEPOSIT)
             */
            getOverrideType: function () {
                if (this.selectedMethod === 'deposit') return 1;
                return null;
            },

            /**
             * 재결제 실행
             */
            submit: function () {
                this.errorMsg = '';
                this.submitting = true;

                var self = this;
                var data = {
                    '_token': self.csrfToken,
                };

                var overrideType = self.getOverrideType();
                if (overrideType !== null) {
                    data['override_payment_method_type'] = overrideType;
                }

                var load = new Promise(function (resolve, reject) {
                    $.app.ajax.module.default({
                        type: 'post',
                        url: '/billing-retry/' + self.billing.id,
                        data: data,
                        success: function (response) {
                            resolve(response);
                        },
                        error: function (jqXHR) {
                            reject(jqXHR);
                        },
                    });
                });

                load.then(function (response) {
                    UIkit.modal(self.$el).hide();

                    if (response.success) {
                        // R-13: 잔여 미수 안내
                        var msg = '재결제가 완료되었습니다.';
                        if (response.remaining_arrears_count !== undefined) {
                            if (response.remaining_arrears_count === 0) {
                                msg += '<br><br><span style="color:#32d296;font-weight:600">모든 미결제가 해결되어 출고제한이 해제됩니다.</span>';
                            } else {
                                msg += '<br><br>아직 <strong>' + response.remaining_arrears_count + '건</strong>의 미결제가 남아있습니다.';
                            }
                        }
                        UIkit.modal.alert(msg).then(function () {
                            $.app.refresh();
                        });
                    } else {
                        UIkit.modal.alert(response.msg || '재결제에 실패하였습니다.').then(function () {
                            $.app.refresh();
                        });
                    }
                }).catch(function (jqXHR) {
                    self.submitting = false;

                    if (jqXHR.responseJSON && jqXHR.responseJSON.msg) {
                        self.errorMsg = jqXHR.responseJSON.msg;
                    } else {
                        self.errorMsg = '재결제 요청 중 오류가 발생했습니다.';
                    }
                });
            },

            /**
             * 숫자 포맷
             */
            numberFormat: function (num) {
                if (!num && num !== 0) return '0';
                return Number(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            },
        },
    };
</script>
